export function useReportLang() {
  const val = localStorage.getItem('jahbath_report_lang');
  return val === 'ar' || val === 'en' ? val : 'ar';
}
